import React from 'react';

interface TimeSlot {
  id: string;
  time: string; // e.g., "14:00"
  available: boolean;
  doctorId?: string;
}

interface TimeSlotGridProps {
  slots: TimeSlot[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  className?: string;
}

export const TimeSlotGrid: React.FC<TimeSlotGridProps> = ({ 
  slots, 
  selectedId, 
  onSelect,
  className = '' 
}) => {
  return (
    <div className={`cab-ts-scroll-wrap ${className}`}>
      <div className="cab-ts-grid">
        {slots.map(slot => (
          <button
            key={slot.id}
            className={`cab-ts-btn ${selectedId === slot.id ? 'active' : ''}`}
            disabled={!slot.available}
            onClick={() => slot.available && onSelect(slot.id)}
          >
            {slot.time}
          </button>
        ))}
      </div>

      <style>{`
        .cab-ts-scroll-wrap {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          padding-bottom: 24px; /* Space for scrollbar */
          width: 100%;
          max-width: 100%;
        }
        .cab-ts-scroll-wrap::-webkit-scrollbar {
          height: 4px;
        }
        .cab-ts-scroll-wrap::-webkit-scrollbar-track {
          background: #FFFFFF;
          border-radius: 4px;
        }
        .cab-ts-scroll-wrap::-webkit-scrollbar-thumb {
          background: #361777;
          border-radius: 4px;
        }
        .cab-ts-grid {
          display: flex;
          flex-wrap: nowrap;
          gap: 8px;
          min-width: max-content;
        }
        .cab-ts-btn {
          flex-shrink: 0;
          min-width: 90px;
          height: 40px;
          border-radius: 100px;
          border: 1px solid transparent;
          background: #FFFFFF;
          color: #361777;
          font-weight: 500;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: 'Poppins', sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
        }
        .cab-ts-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
          border-color: transparent;
        }
        .cab-ts-btn:not(:disabled):hover {
          border-color: #EBECEF;
        }
        .cab-ts-btn.active {
          background: #361777;
          border-color: #361777;
          color: #FFFFFF;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .cab-ts-btn {
            border: 1px solid #361777;
            background: transparent;
          }
          .cab-ts-btn:disabled {
            border-color: #A9A2C2;
            color: #A9A2C2;
          }
          .cab-ts-btn:not(:disabled):hover {
            background: #F8F6FC;
          }
          .cab-ts-btn.active {
            background: #361777;
            color: #FFFFFF;
          }
        }
      `}</style>
    </div>
  );
};
